import React from "react";

import { Tab } from "react-bootstrap";
import { Wallet } from "iconsax-react";

import {
  ROUTE_MY_WALLET_DEPOSIT,
  ROUTE_MY_WALLET_WITHDRAW,
} from "../../../../../routes";

import UserTabsComponent from "../../../tabs";
import ButtonComponent from "../../../../public/button";
import UserWalletHistoryContainer from "../../../../../containers/profile/wallet/history";
import UserWalletWithdrawReportsContainer from "../../../../../containers/profile/wallet/withdrawReports";

import {
  ContainerPriceContent,
  ContainerPriceIcon,
  ContainerPriceInfo,
  ContainerWalletHeader,
  ContainerWalletInfo,
  PriceContainer,
  SectionWalletInfo,
  WalletHeader,
  WithdrawButton,
} from "./styledUserWalletComponent";

function UserWalletComponent() {
  return (
    <SectionWalletInfo>
      <ContainerWalletHeader>
        <WalletHeader>کیف پول</WalletHeader>
        <p>
          تمامی مبالغ کیف پول قابل استفاده برای خرید های تخفیفاتی شما میباشد.
        </p>
      </ContainerWalletHeader>
      <div className={"d-flex justify-content-around"}>
        <ContainerWalletInfo className="col-sm-6">
          <div className={"d-flex flex-column p-2 justify-content-center "}>
            <ContainerPriceInfo
              withBorder
              className={"d-flex align-items-center"}
            >
              <ContainerPriceIcon>
                <Wallet />
              </ContainerPriceIcon>
              <ContainerPriceContent>
                مبلغ قابل برداشت: <PriceContainer>تومان 10,000</PriceContainer>
              </ContainerPriceContent>
              <WithdrawButton to={ROUTE_MY_WALLET_DEPOSIT}>
                افزودن موجودی
              </WithdrawButton>
            </ContainerPriceInfo>
            <ContainerPriceInfo className={"d-flex align-items-center"}>
              <ContainerPriceIcon>
                <Wallet />
              </ContainerPriceIcon>
              <ContainerPriceContent>
                کل مبلغ برداشتی از کیف پول(تا امروز):
                <PriceContainer>تومان 10,000</PriceContainer>
              </ContainerPriceContent>
            </ContainerPriceInfo>
          </div>
        </ContainerWalletInfo>
        <ContainerWalletInfo className="col-sm-5">
          <div
            className={
              "d-flex flex-column p-2 justify-content-center align-items-center"
            }
          >
            <ContainerPriceInfo>
              <ContainerPriceContent>
                مبلغ قابل برداشت: <PriceContainer>تومان 10,000</PriceContainer>
              </ContainerPriceContent>
            </ContainerPriceInfo>
            <ButtonComponent isLink={true} to={ROUTE_MY_WALLET_WITHDRAW}>
              برداشت وجه
            </ButtonComponent>
          </div>
        </ContainerWalletInfo>
      </div>

      <UserTabsComponent className={"my-4"}>
        <Tab title={"تاریخچه کیف پول"} eventKey={"walletHistory"}>
          <UserWalletHistoryContainer />
        </Tab>
        <Tab title={"گزارشات برداشت"} eventKey={"walletReports"}>
          <UserWalletWithdrawReportsContainer />
        </Tab>
      </UserTabsComponent>
    </SectionWalletInfo>
  );
}

export default UserWalletComponent;
